import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Swatch } from '../common';
const styles = {
    colors: (flag) => ({
        margin: '0 -10px',
        padding: '10px 0 0 10px',
        borderTop: '1px solid #eee',
        display: 'flex',
        flexWrap: 'wrap',
        position: 'relative',
        ...(flag && { display: 'none' }),
    }),
    swatchWrap: {
        width: '16px',
        height: '16px',
        margin: '0 10px 10px 0',
    },
    swatch: {
        borderRadius: '3px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)',
    },
};
const SketchPresetColors = (props) => {
    const { colors, onClick, onSwatchHover } = props;
    const handleClick = useCallback((hex, e) => {
        onClick?.({
            hex,
            source: 'hex',
        }, e);
    }, [onClick]);
    return (_jsx("div", { style: styles.colors(!colors || colors.length === 0), children: colors.map((colorObjOrString) => {
            const c = typeof colorObjOrString === 'string'
                ? { color: colorObjOrString }
                : colorObjOrString;
            const key = `${c.color}${'title' in c ? c?.title : ''}`;
            return (_jsx("div", { style: styles.swatchWrap, children: _jsx(Swatch, { ...c, style: styles.swatch, onClick: handleClick, onHover: onSwatchHover, focusStyle: {
                        boxShadow: `inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ${c.color}`,
                    } }) }, key));
        }) }));
};
export default SketchPresetColors;
//# sourceMappingURL=SketchPresetColors.js.map